module.exports = __webpack_public_path__ + "img/icon-wtjdr.2191d5a6.png";